import { render, staticRenderFns } from "./ManualHomeworksWidget.vue?vue&type=template&id=2c12b77a"
import script from "./ManualHomeworksWidget.vue?vue&type=script&lang=js"
export * from "./ManualHomeworksWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c12b77a')) {
      api.createRecord('2c12b77a', component.options)
    } else {
      api.reload('2c12b77a', component.options)
    }
    module.hot.accept("./ManualHomeworksWidget.vue?vue&type=template&id=2c12b77a", function () {
      api.rerender('2c12b77a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/dashboard_widgets/ManualHomeworksWidget.vue"
export default component.exports